import React from "react";
import { Typography } from "antd";
const { Title } = Typography;

const Header = ({ text }) => {
  return (
    <Title
      style={{
        marginTop: "40px",
        color: "#0a4148",
        fontWeight: "bold",
        fontSize: "24px",
        marginBottom: "25px",
        textTransform: "uppercase",
      }}
    >
      {text}
    </Title>
  );
};

export default Header;
